import React, { useState } from "react";
import { Box, Tab, Tabs, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Paper, IconButton } from "@mui/material";

const columns = [
    { id: "timeZone", label: "Time Zone", align: "left", sortable: true },
    { id: "countryCode", label: "Country Code", align: "left", sortable: true },
    { id: "countryName", label: "Country Name", align: "left", sortable: true },
    { id: "countryCodeId", label: "Country Code Id", align: "left", sortable: true },
];

const data = [
    { id: 1, timeZone: "Asia/Kolkata (GMT+5:30)", countryCode: "+91", countryName: "India", countryCodeId: 1 },
    { id: 2, timeZone: "Asia/Kabul (GMT+4:30)", countryCode: "+93", countryName: "Afghanistan", countryCodeId: 2 },
];

const columnsForDataProfile = [
    { id: "sequence", label: "SEQUENCE", align: "left", sortable: true, minWidth: '80px' },
    { id: "name", label: "NAME", align: "left", sortable: true, minWidth: '120px' },
    { id: "primarykey", label: "PRIMARY KEY", align: "left", sortable: true, minWidth: '150px' },
    { id: "dataType", label: "DATA TYPE", align: "left", sortable: true, minWidth: '150px' },
    { id: "maxLength", label: "MAX LENGTH", align: "left", sortable: true, minWidth: '150px' },
    { id: "formatMask", label: "FORMAT MASK", align: "left", sortable: true, minWidth: '150px' },
    { id: "hasTimeZone", label: "HAS TIME ZONE", align: "left", sortable: true, minWidth: '150px' },
    { id: "selector", label: "SELECTOR", align: "left", sortable: true, minWidth: '150px' },
];

const dataForDataProfile = [
    { id: 1, sequence: "1", name: "TIMEZONE", primarykey: "No", dataType: "VARCHAR2", maxLength: "32767", formatMask: "-", hasTimeZone: "No", selector: "TimeZone" },
    { id: 2, sequence: "2", name: "COUNTRYCODE", primarykey: "NO", dataType: "NUMBER", maxLength: "-", formatMask: "-", hasTimeZone: "No", selector: "CountryCode" },
    { id: 3, sequence: "3", name: "COUNTRYNAME", primarykey: "No", dataType: "VARCHAR2", maxLength: "32767", formatMask: "-", hasTimeZone: "No", selector: "CountryName" },
];

const PreviewComponent = () => {
    const [activeTab, setActiveTab] = useState(0);

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleRequestSort = (event, columnId) => {
        console.log(`Sort triggered on column: ${columnId}`);
    };

    const handleSyncDataClick = () => {
        console.log("Sync Data clicked");
    };

    return (
        <Box sx={{ width: "100%", typography: "body1" }}>
            <Tabs value={activeTab} onChange={handleChange} aria-label="Preview Tabs">
                <Tab label="Data" />
                <Tab label="Data Profile" />
                <Tab label="Response Body" />
            </Tabs>
            <Box sx={{ mt: 2 }}>
                {/* Tab Content */}
                {activeTab === 0 && (
                    <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="table-container">
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                            <div style={{ display: "flex", alignItems: "center" }} className="table-header-div">
                                                {column.label}
                                                {column.sortable !== false && (
                                                    <IconButton size="small" onClick={(event) => handleRequestSort(event, column.id)}>
                                                        {/* <img src={SortIcon} alt="Sort" /> */}
                                                    </IconButton>
                                                )}
                                            </div>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <TableRow key={row.id}>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align}>
                                                {row[column.id]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {activeTab === 1 && (
                    <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="table-container">
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {columnsForDataProfile.map((column) => (
                                        <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                            <div style={{ display: "flex", alignItems: "center" }} className="table-header-div">
                                                {column.label}
                                                {column.sortable !== false && (
                                                    <IconButton size="small" onClick={(event) => handleRequestSort(event, column.id)}>
                                                        {/* <img src={SortIcon} alt="Sort" /> */}
                                                    </IconButton>
                                                )}
                                            </div>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataForDataProfile.map((row) => (
                                    <TableRow key={row.id}>
                                        {columnsForDataProfile.map((column) => (
                                            <TableCell key={column.id} align={column.align}>
                                                {row[column.id]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {activeTab === 2 && (
                    <Box sx={{ padding: 2 }}>
                        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                            {JSON.stringify(
                                {
                                    Success: 1,
                                    CountryCodes: [
                                        {
                                            CountryCodeID: 1,
                                            CountryCode: "+91",
                                            CountryName: "India",
                                            TimeZone: "Asia/Kolkata (GMT+5:30)",
                                        },
                                        {
                                            CountryCodeID: 2,
                                            CountryCode: "+93",
                                            CountryName: "Afghanistan",
                                            TimeZone: "Asia/Kabul (GMT+4:30)",
                                        },
                                        // Add more countries as needed
                                    ],
                                },
                                null,
                                2 // Indentation for readability
                            )}
                        </pre>
                    </Box>
                )}

            </Box>
        </Box>
    );
};

export default PreviewComponent;
